import { render, staticRenderFns } from "./CellUserSwitchButtons.vue?vue&type=template&id=f1ecad0a&"
import script from "./CellUserSwitchButtons.vue?vue&type=script&lang=js&"
export * from "./CellUserSwitchButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports